module.exports = __webpack_public_path__ + "static/media/koala.ca505a74.svg";